import { get as _get } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../store/actions';
import api from '../store/api';
import { store } from '../store';

export const projectStartSearch = (property_address_value, history) => {

	return api
		.get('/geocode-address/', { address: property_address_value })
		.then((res) => {

			if (!res.data.address) {
				throw {"reject": "That address isn't valid"}
			}

			store.dispatch(actions.formFlow.clearFormFlow());
			store.dispatch(actions.infoFeed.clearInfoFeedDisplay());
			// todo: edit this so we only same some program attributes and not all
			store.dispatch(actions.projectLeads.setFocusedProject(res.data.id)); // make it empty so we know we are creating a new one and this is not an edit.

			// we set the name of the project, as well as the searched address, to what they searched. That way we can store/recreate if needed.
			store.dispatch(
				actions.formFlow.updateFormFlowInputs({
					searched_address: property_address_value,
					project_name: property_address_value,
				})
			);
			store.dispatch(
				actions.formFlow.updateFormFlowComputed({
					...res.data,
					pace_funders_available: res.data?.funders_available,
					programs: _get(res, 'data.programs', []).map((d) => ({
						id: d.id,
						district_id: d.district_id,
					})),
				})
			);
			store.dispatch(
				actions.infoFeed.updateInfoFeedDisplay({
					property_address: {
						_property_address: res.data.address.formatted_address,
					},
				})
			);

			history.push('/project');

		})

};
